export const actionTypes = {
  CREATOR_INFO_AGENCY_FETCH_BEGIN: 'CREATOR_INFO_AGENCY_FETCH_BEGIN',
  CREATOR_INFO_AGENCY_FETCH_SUCCESS: 'CREATOR_INFO_AGENCY_FETCH_SUCCESS',
  CREATOR_INFO_AGENCY_FETCH_FAIL: 'CREATOR_INFO_AGENCY_FETCH_FAIL',
};
